
import { getAccessControlEnabledPLBModules } from "../../../../../../../../pageTpls/PlatformBuilder/config";
import {
  __CheckAccessToModule,
  __CheckAccessViaConfig,
  __CheckSomeAccessToSomeContentType,
  __CheckSomeAccessToSomePlatformBuilderModule,
  __GetAccessibleContentTypes,
} from "../../../../../../../../utils/accessControl";

import { useGetQueryData } from "../../../../../../../../utils/react-query-hooks/general";
import { genMyDashboardMenuOptions } from "../../../../../../MyDashboardMenu/utils";


export const useGetMyAccountMenuOptions = () => {
  const userData = useGetQueryData("userData");
  const allTpls = useGetQueryData('allTpls')

  const { SELF_MANAGED_BASE_CONFIGS } = useGetQueryData('platformConfigs')
  const {
    myAccountMenuOptionsWhitelist: SELF_myAccountMenuOptionsWhitelist , 
    myAccountMenuCustomOptions : SELF_myAccountMenuCustomOptions , 
    enable : isSelfManagedEnabled
  } = SELF_MANAGED_BASE_CONFIGS || {}
  
  /**
   * my dashboard options are dynamic, and they change from
   * tenant to tenant, role to role. hence the function below, to fetch
   * the 'landing view' of my dashboard for THIS user on THIS tenant
   */
  const getFirstMyDashboardOp = () => {
    return genMyDashboardMenuOptions(userData).find((d) => d.links.length > 0)
      .links[0];
  };

  const myDashboardOp = {
    display: "My Dashboard",
    value: 'myDashboard', 
    to: getFirstMyDashboardOp().link,
  };

  const myProfileSettingsOp =
   { 
    display: "Profile Settings", 
    value: 'profileSettings', 
    to: `/my-dashboard/MyProfile` 
  };

  const myContentOp = {
    display: "My Content",
    value: 'myContent', 
    to: { pathname: `/my-dashboard/MyContent`, search: `?activeTab=draft` },
  };

  const reviewDashboardOp =  (
    __CheckSomeAccessToSomeContentType({
      user: userData?.user,
      actions: ['MODERATE'],
      contentTypes: allTpls.filter(tpl => tpl.general?.segment === 'publishing' ).map(d => d.kp_content_type)
    }) && 
    {
      display: 'Review Dashboard', 
      value: 'reviewDashboard', 
      to: `/my-dashboard/ModQueue`,
    }
  )

  const hasPlatformBuilderAccess = 
    __CheckSomeAccessToSomePlatformBuilderModule({
      user: userData?.user,
      actions: ['READ', 'UPDATE'],
      modules: getAccessControlEnabledPLBModules().map(m => m.value)
    }) || 
    __CheckAccessToModule(userData?.user, 'READ', 'usersManager'); // usersManager module check (non-self-managed)

  const platformBuilderOp =  (
    hasPlatformBuilderAccess && 
    {
      display: 'Admin Dashboard', 
      value: 'platformBuilder', 
      to: `/platformBuilder`,
    }
  )

  const logoutOp = { display: "Logout", value: "logout" };

  const toReturn = [
    myDashboardOp,
    myProfileSettingsOp,
    myContentOp,
    reviewDashboardOp,
    platformBuilderOp,
    logoutOp,
  ]
  .filter(Boolean)


  const SELF_MANAGED_ACCOUNT_MENU_OPTIONS = 
    [ ...(SELF_myAccountMenuCustomOptions?.map(op => {
      return !op.accessConfig
        ? op
        : __CheckAccessViaConfig({user: userData?.user, ...op.accessConfig})
          ? op
          : undefined
    }).filter(Boolean) || []), 
      ...toReturn.filter(d => {

          if(SELF_myAccountMenuOptionsWhitelist && SELF_myAccountMenuOptionsWhitelist.length > 0) {
                return SELF_myAccountMenuOptionsWhitelist.includes(d.value)
            }
            return true;
    })]


  if(isSelfManagedEnabled || SELF_MANAGED_ACCOUNT_MENU_OPTIONS?.length > 0) {
    return SELF_MANAGED_ACCOUNT_MENU_OPTIONS
  }

  return toReturn
  
};
